


















import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'ContentNotify'
})
export default class extends Vue {
  showNav = true
}
